import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, List, X, Sun } from "@phosphor-icons/react";
import { COMPANY } from "../lib/constants";

const navItems = [
  { to: "/", label: "Accueil", slug: "accueil" },
  { to: "/services", label: "Services", slug: "services" },
  { to: "/comment-ca-marche", label: "Comment ça marche", slug: "comment-ca-marche" },
  { to: "/eligibilite", label: "Éligibilité", slug: "eligibilite" },
  { to: "/contact", label: "Contact", slug: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-700 to-emerald-500 flex items-center justify-center shadow-sm">
              <Sun size={22} weight="fill" color="#FFFFFF" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-slate-900 text-base md:text-lg">
                Hélios Solutions
              </div>
              <div className="text-[11px] md:text-xs text-slate-500 -mt-0.5">
                Énergie & Habitat
              </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.slug}`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? "text-blue-700 bg-blue-50"
                      : "text-slate-700 hover:text-blue-700 hover:bg-slate-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={COMPANY.phoneHref}
              data-testid="header-call-btn"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 rounded-lg font-semibold text-sm btn-primary-eco"
            >
              <Phone size={18} weight="fill" />
              <span className="hidden md:inline">{COMPANY.phone}</span>
              <span className="md:hidden">Appeler</span>
            </a>
            <Link
              to="/eligibilite"
              data-testid="header-eligibility-btn"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-lg font-semibold text-sm btn-secondary-eco"
            >
              Vérifier mon éligibilité
            </Link>
            <button
              data-testid="mobile-menu-toggle"
              className="lg:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <X size={22} /> : <List size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-slate-200 py-3 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.slug}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block px-3 py-2.5 rounded-lg text-sm font-medium ${
                    isActive
                      ? "text-blue-700 bg-blue-50"
                      : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={COMPANY.phoneHref}
              data-testid="mobile-call-btn"
              className="flex items-center gap-2 mt-2 px-3 py-3 rounded-lg font-semibold btn-primary-eco"
            >
              <Phone size={18} weight="fill" /> {COMPANY.phone}
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
